<template>
  <div :class="name">
    <h2>사용자보기</h2>
    <el-table :id="`${name}`"
              :class="`${name}`"
              :data="members"
              border
              ref="tableData"
              :row-class-name="({ row }) => row.id"
              @row-click="handleList"
              size="mini"
              :fit="true"
              >

      <!-- tag를 쓰고 (범위설정 ) 액션을 넣는다. -->
      <!-- 테그에 마우스 오버 하면 니스트를 보여 준다. -->
      <!-- 예외 사항은 domain을 제외 한다.  -->
      <el-table-column type="expand" :column-key="`${'expand'}`">
        <template slot-scope="props">
          <h3>{{copiedMember.name}} ( <a :href="`mailto:${copiedMember.email}`" target="_blank"> {{copiedMember.email}} </a> ) </h3>


          <div class="permission">
            <h4>사용자 권한 톤합 보기</h4>

            <div v-for="(affiliatedTeam, key) in copiedMember.affiliatedTeams"
                 :key="key">
              {{teams[key].name}}
              <ul>
                <li v-for="(service, serviceId) in services"
                    :key="serviceId"
                    v-if="teams[affiliatedTeam.id].permissions[serviceId].length > 0">
                  {{service.name}} 서비스에서
                  <template v-for="(item, index) in teams[affiliatedTeam.id].permissions[serviceId]">
                    <span v-if="item.split(':')[0] === 'tag'"
                        :key="`tag_${index}`">

                      <el-popover placement="top-start"
                                  :title="`${item.split(':')[1]}에 속한 도메인`"
                                  width="500"
                                  trigger="click">
                        <span v-for="(domain, index) in teams[affiliatedTeam.id].viewData[serviceId].tags[item.split(':')[1]]"
                              :key="index">{{domain}}, </span>
                        <el-button size="small" slot="reference">*{{item.split(':')[1]}}</el-button>
                      </el-popover>
                    </span>
                    <span v-else
                        :key="`item_${index}`">
                      <el-button size="small">{{service.range_group[item].full_name}}</el-button>
                    </span>
                  </template>
                  의 도메인에 접속하여

                  <template v-for="(job) in affiliatedTeam.job">
                    <template v-for="(action) in jobs[job].permissions[serviceId]"> {{action}},</template>
                  </template>
                  할 권한을 가진다.
                </li>
              </ul>
              <div v-if="affiliatedTeam.exception.length > 0">
                {{teams[affiliatedTeam.id].name}}팀에서 요청한 예외사항
                <ul>
                  <li v-for="(exception, index) in affiliatedTeam.exception"
                      :key="`exception_${index}`">
                    {{services[exception.split('-')[0]].name}}의
                    {{services[exception.split('-')[0]].range_group[exception.split('-')[1]].full_name}}에서
                    {{services[exception.split('-')[0]].action_group[exception.split('-')[2]].title}}권한이 부여되거나 삭제 된다.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!---->

          <div class="permission">
            <h4>사용자 권한 보기</h4>
            <div v-for="(service, serviceId) in deleteAnEmptyPermissionList(copiedMember.viewData)"
                :key="`service_${serviceId}`">

              <div style="background-color: black; color: white; padding: 3px;">{{serviceId}}</div>
              <el-row :gutter="24">
                <el-col v-for="(domain, domainId) in service"
                        :key="`domain_${domainId}`"
                        :span="3">
                  {{domainId}}
                  <ul>
                    <li v-for="(facility, facilityName) in domain"
                        :key="`facility_${facilityName}`">
                      <span :class="getClass(facility)">{{facility.id}}</span>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </div>
          </div>


          <!--사용자의 팀별 담당 업무 변경 -->

          <ul>
            <li v-for="(affiliatedTeam, key) in copiedMember.affiliatedTeams"
                :key="key">
              <div>
                {{teams[key].name}}팀 :

                <template v-if="!teams[affiliatedTeam.id].is_division">
                  사용자는 팀의 모든 사이트를 담당 한다.
                </template>
                <template v-else>
                  담당:

                  {{teams[affiliatedTeam.id].division}}
                  <el-select v-model="affiliatedTeam.division"
                             multiple
                             placeholder="Select"
                             @change="makeSelectRowViewData(copiedMember)">
                    <el-option
                      v-for="item in teams[affiliatedTeam.id].division"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>에서
                </template>

                <el-select v-model="affiliatedTeam.job"
                           multiple
                           placeholder="Select"
                           @change="makeSelectRowViewData(copiedMember)">
                  <el-option
                    v-for="job in Object.keys(jobs)"
                    :key="job"
                    :label="job"
                    :value="job">
                  </el-option>
                </el-select>일을 수행.

                <el-button size="mini"
                           @click="handleEditTeam(index)"
                           type="warning">팀 수정</el-button>
              </div>
            </li>
          </ul>

          <!--사용자의 예외 업무 변경 -->
          <el-tabs tab-position="left"
                   class="permission">
            <el-tab-pane  v-for="(service, serviceId) in copiedMember.viewData"
                          :key="`service_${serviceId}`"
                          :label="serviceId">
              <el-row :gutter="24">
                <el-col v-for="(domain, domainId) in service"
                        :key="`domain_${domainId}`"
                        :span="8">
                  {{domainId}}
                  <ul style="padding-left: 0">
                    <li v-for="(facility, facilityName) in domain"
                        :key="`facility_${facilityName}`"
                        style="list-style: none; white-space: normal">
                      <el-checkbox v-model="facility.selected"
                                   @change="changeFacility(serviceId, domainId, facilityName)">
                        <span :class="getClass(facility)">
                          {{facility.id}}
                        </span>
                      </el-checkbox>
                    </li>
                  </ul>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>


          <div>
            <el-button @click="handleList(props.row, 'top')"
                       size="mini"
                       type="warning">scroll top</el-button>
            <el-button @click="handleEditException"
                       size="mini"
                       type="warning">예외사항 처리</el-button>
          </div>
        </template>
      </el-table-column>
      <template v-for="(key) in localIndicator2">
        <el-table-column :prop="`${key}`"
                         :key="key"
                         :label="key"
                         :sortable="true"
                         :column-key="key">
          <template slot-scope="scope">
            <template v-if="key === 'name'">
              <strong :class="scope.row.id">{{getName(key, scope.row)}}</strong>
            </template>
            <template v-else-if="key === 'exception'">
              <div v-html="getName(key, scope.row)"></div>
            </template>
            <template v-else-if="key === 'affiliatedTeams'">
              <ul>
                <li v-for="(affiliatedTeam, key) in scope.row.affiliatedTeams"
                    :key="`permission_${key}`">
                  <strong>{{teams[key].name}}</strong> :
                  <!--<span v-if="affiliatedTeam.division[0] === 'all'">모든 게임의 </span>-->
                  <!--<span v-else-if="affiliatedTeam.division[0] === 'anipang'"></span>-->
                  <span v-if="affiliatedTeam.division.length > 0">{{affiliatedTeam.division.join(', ')}}의 </span>
                  <span>{{affiliatedTeam.job.join(',')}}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              {{getName(key, scope.row)}}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <ChangePermissionDialog v-if="{}.hasOwnProperty.call(copiedMember, 'viewData')"
                            :editPermissionData="copiedMember.viewData"
                            :permissionData="members[0].viewData"
                            :dialogVisible="dialogVisible"
                            :selectedRow="selectedRow"
                            @close='UpdateDialogVisible'/>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import ChangeMemberSettingsDialog2 from '@/container/ChangeMemberSettingsDialog2';
import ChangePermissionDialog from '@/container/ChangePermissionDialog';

import getClassNameByException from '@/filters/getClassNameByException';
import getDeleteAnEmptyPermission from '@/filters/getDeleteAnEmptyPermission';
import filterTeamView from '@/filters/getTeamViewData';
import filterMemberView from '@/filters/getMemberViewData';
import getName from '@/mixins/getName';

export default {
  filters: {
    getClassNameByException,
    getDeleteAnEmptyPermission,
    filterTeamView,
    filterMemberView,
  },
  mixins: [
    getName,
  ],
  components: {
    // ChangeMemberSettingsDialog2,
    ChangePermissionDialog,
  },
  computed: {
    ...mapGetters([
      'games',
      'jobs',
      'teams',
      'services',
      'members',
    ]),
  },
  methods: {
    handleList(row, target) {
      if (target === 'top') {
        this.setScroll(0);
      }
      this.rowClicked(row);
    },

    rowClicked(row, isSearch, isUpdate) {
      if (this.selectedRow) {
        if (this.selectedRow.id !== row.id) {
          this.$refs.tableData.toggleRowExpansion(this.selectedRow);
          this.makeSelectRowViewData(row);
          this.$refs.tableData.toggleRowExpansion(row);
          this.selectedRow = row;
        } else if (isSearch) {
          if (isUpdate) {
            this.makeSelectRowViewData(row);
            this.$refs.tableData.toggleRowExpansion(row);
            this.selectedRow = row;
          } else {
            this.selectedRow = row;
          }
        } else {
          this.$refs.tableData.toggleRowExpansion(row);
          this.selectedRow = null;
        }
      } else {
        this.makeSelectRowViewData(row);
        this.$refs.tableData.toggleRowExpansion(row);
        this.selectedRow = row;
      }
    },

    makeSelectRowViewData(row) {
      this.copiedMember = filterMemberView.setMemberView(row, this.services, this.teams);
    },

    deleteAnEmptyPermissionList(permissionData) {
      return getDeleteAnEmptyPermission(permissionData);
    },

    setScroll(location) {
      window.scrollTo({
        top: location,
        behavior: 'smooth',
      });
    },
    getClass(facility) {
      return getClassNameByException(facility);
    },

    handleEditException() {
      this.dialogVisible = true;
    },

    UpdateDialogVisible(aaa) {
      this.dialogVisible = aaa;
    },

    changeFacility(serviceId, domainId, facilityName) {
      let newExceptions = [];
      const changeFacilityName = `${serviceId}-${domainId}-${facilityName}`;
      const facility = this.copiedMember.viewData[serviceId][domainId][facilityName];

      facility.isChange = !facility.isChange;
      if (facility.isDefault) {
        facility.isException = !facility.isException;
      } else {
        facility.isException = facility.selected;
      }

      if (!this.copiedMember.exception.includes(changeFacilityName)) {
        newExceptions = [changeFacilityName, ...this.copiedMember.exception];
      } else {
        this.copiedMember.exception.forEach((exception) => {
          if (exception !== changeFacilityName) {
            newExceptions.push(exception);
          }
        });
      }
      this.copiedMember.exception = newExceptions;
    },
  },
  data() {
    return {
      name: 'EmployeeList',
      localIndicator2: [
        'id',
        'name',
        'affiliatedTeams',
        // 'exception',
      ],
      selectedRow: null,
      dialogVisible: false,
      copiedMember: {},
    };
  },
};
</script>

<style lang="scss">
  .permission {
    .addException {
      color: red;
    }
    .removeException {
      color: orange;
    }
    .default {
      color: blue;
    }
    .normal {
      color: black;
    }
  }
  .el-select .el-input {
    width: 110px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/container/EmployeeList.vue